
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"58pt","height":"24","viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56.848 22.242c-.77-.765-1.707-1.152-2.805-1.152H3.953c-1.098 0-2.031.387-2.8 1.152C.382 23.012 0 23.945 0 25.043v7.91c0 1.102.383 2.035 1.152 2.8.77.77 1.703 1.153 2.801 1.153h50.09c1.098 0 2.035-.383 2.8-1.152.77-.766 1.157-1.7 1.157-2.8v-7.911c0-1.098-.387-2.031-1.152-2.8zm0 0"}})])
          )
        }
      }
    